import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useSession } from "users/__session/session-context";
import { CanceledError } from "axios";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material";
import EntityOfficerInvitationAPIService from "legal-entities/invitations/officer-invitations/_api/entity-officer-invitation-api-service";
import EntityOfficerInvitationForm from "legal-entities/invitations/officer-invitations/_views/components/entity-officer-invitation-form";
import EntityOfficerInvitationsTable from "legal-entities/invitations/officer-invitations/_views/components/entity-officer-invitations-table";
import EntityOfficerInvitation from "legal-entities/invitations/officer-invitations/entity-officer-invitation";

const StyledEntitiesContainer = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.down("xl")]: {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto",
  },
  display: "grid",
  gridTemplateColumns: "1fr 2fr",
  gridTemplateRows: "1fr",
  padding: theme.spacing(1),
  position: "relative",
  overflowY: "auto",
  height: "100%",
  width: "100%",
}));

export default function EntitiesPage() {
  const [openInvitations, setOpenInvitations] = useState<EntityOfficerInvitation[]>();
  const session = useSession();

  async function getOpenInvitations() {
    if (openInvitations !== undefined) return;
    try {
      const service = new EntityOfficerInvitationAPIService(session);
      const returnedInvitations = await service.getAllOpenOfficerInvitations();
      setOpenInvitations(returnedInvitations);
    } catch (error) {
      if (error instanceof CanceledError) {
        return;
      }

      console.error(error);
      enqueueSnackbar("Failed to get open invitations", { variant: "error" });
    }
  }

  void getOpenInvitations();

  return (
    <StyledEntitiesContainer>
      <EntityOfficerInvitationForm
        onInvitationCreated={(invitation) => setOpenInvitations([...(openInvitations ?? []), invitation])}
      />
      <EntityOfficerInvitationsTable
        session={session}
        invitations={openInvitations ?? []}
        onInvitationRemoved={(invitation) => setOpenInvitations(openInvitations?.filter((i) => i.id !== invitation.id))}
      />
    </StyledEntitiesContainer>
  );
}
